"use client";

import CommonSchema from "@/components/common/CommonSchema";
import { motion } from "motion/react";
// import {
//   Award,
//   Heart,
//   Shield,
//   Leaf,
//   Target,
//   Sparkles,
//   MapPin,
//   Building2,
//   BedDouble,
//   Waves,
//   Users,
//   Plane,
//   Train,
//   Compass,
//   Dumbbell,
//   Flower2,
//   Utensils,
//   PartyPopper,
//   Briefcase,
//   Bike,
//   Flame,
//   Gamepad2,
//   Smile,
//   GlassWater,
//   ShieldCheck,
//   CheckCircle2,
// } from "lucide-react";
import Link from "next/link";
import Image from "next/image";
import { FadeInSection } from "@/components/common/FadeInSection";
import { Banner } from "@/components/common/Banner";
import { useAppSelector } from "@/store/hooks";
import { useEffect, useState } from "react";
import {
  cleanHeaderTags,
  createLookupObject,
  isValidImgSrc,
} from "@/_helper/helper";

export default function AboutClient({
  cmsData,
  initialBanner,
}: {
  cmsData: any[];
  initialBanner?: any;
}) {
  const BannerList = useAppSelector((state) => state.home.BannerList);
  const banner: any =
    initialBanner ||
    BannerList?.find((banner: any) => banner?.BannerType === "about") ||
    {};

  const [lookUpCMSData, setLookUpCMSData] = useState<Record<string, any>>({});

  useEffect(() => {
    if (cmsData && cmsData.length > 0) {
      setLookUpCMSData(createLookupObject(cmsData, "Name"));
    }
  }, [cmsData]);

  // const locationFacts = [
  //   {
  //     label: "Location",
  //     value: "Lake Bagela, Nagda, near Eklingji, Udaipur",
  //     icon: MapPin,
  //   },
  //   {
  //     label: "Nearest Airport",
  //     value: "Maharana Pratap Airport, Udaipur (approximately 45 km away)",
  //     icon: Plane,
  //   },
  //   {
  //     label: "Nearest Railway",
  //     value: "Udaipur City Railway Station (approximately 25 km away)",
  //     icon: Train,
  //   },
  //   {
  //     label: "Nearby Attractions",
  //     value: "Eklingji Temple, Udaipur City Palace, Kumbhalgarh Fort, Crystal Gallery, Bagore Ki Haveli, Pichola Lake, Ranakpur Temple",
  //     icon: Compass,
  //   },
  // ];

  // const amenities = [
  //   { title: "Rooftop Lounge Facilities", icon: GlassWater, desc: "Lakeside sunset views & beverages" },
  //   { title: "Picnic Area with BBQ", icon: Flame, desc: "Private outdoor barbecue setups" },
  //   { title: "Outdoor Badminton", icon: Sparkles, desc: "Lush garden lawn court" },
  //   { title: "Children's Playground", icon: Smile, desc: "Safe play area for kids" },
  //   { title: "Candlelight Dinner", icon: Heart, desc: "Romantic lakeside dining" },
  //   { title: "Indoor Games", icon: Gamepad2, desc: "Recreational gaming lounge" },
  //   { title: "Gym & Fitness Center", icon: Dumbbell, desc: "Modern wellness equipment" },
  //   { title: "Spa", icon: Flower2, desc: "Rejuvenating massages & therapies" },
  //   { title: "Horse Ride", icon: Sparkles, desc: "Royal equestrian experience" },
  //   { title: "E-Cycling", icon: Bike, desc: "Guided eco-friendly nature rides" },
  // ];

  // const roomCategories = [
  //   {
  //     name: "Luxury Pool Suite",
  //     size: "550 sq ft villa (150 sq ft pool)",
  //     tagline: "Private Pool • Couples Escape • Intimate Luxury",
  //     description:
  //       "One of the finest private pool suites in Udaipur, this 550 sq ft villa comes with its own 150 sq ft private pool, ideal for couples seeking complete privacy, comfort, and an intimate escape.",
  //     icon: Waves,
  //   },
  //   {
  //     name: "Lake View Suite",
  //     size: "450 sq ft suite",
  //     tagline:
  //       "Lake Bagela Panorama • Private Balcony • Floor-to-Ceiling Windows",
  //     description:
  //       "Widely regarded as the best lake view room in Udaipur, this 450 sq ft suite features floor-to-ceiling windows and a private balcony overlooking Lake Bagela, offering uninterrupted waterside views and calm.",
  //     icon: Compass,
  //   },
  //   {
  //     name: "Garden View Suite",
  //     size: "Spacious luxury layout",
  //     tagline: "Lush Green Scenery • Quiet Ambiance • Family Staycation",
  //     description:
  //       "A peaceful garden view room in Udaipur, set amid quiet, green surroundings and well suited for relaxed, longer stays and family visits.",
  //     icon: Building2,
  //   },
  // ];

  // const eventsList = [
  //   {
  //     title: "Boutique Weddings",
  //     desc: "Destination wedding venue with end-to-end planning support.",
  //     icon: Heart,
  //   },
  //   {
  //     title: "Destination Weddings",
  //     desc: "Palatial settings for elaborate multi-day wedding celebrations.",
  //     icon: Sparkles,
  //   },
  //   {
  //     title: "Corporate Events",
  //     desc: "Premium conference venues and banquet halls for professional gatherings, board meetings, and conferences.",
  //     icon: Briefcase,
  //   },
  //   {
  //     title: "Social Gatherings",
  //     desc: "Flexible spaces for family celebrations and social occasions.",
  //     icon: Users,
  //   },
  //   {
  //     title: "Birthday & Anniversary Celebrations",
  //     desc: "Customizable venues with themed décor options.",
  //     icon: PartyPopper,
  //   },
  //   {
  //     title: "Pool Parties",
  //     desc: "Trendy poolside venue with entertainment setup for social celebrations.",
  //     icon: Waves,
  //   },
  // ];

  return (
    <div className="min-h-screen bg-[#fdfcfa]">
      <CommonSchema />
      <script
        id="localbusiness-schema"
        type="application/ld+json"
        suppressHydrationWarning
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Sarasiruham Resort",
            image: banner?.BannerImage || "",
            description:
              "Luxury 4.5-star resort in Udaipur with private pool villas, spa, and lakeside location near Eklingji Temple",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Lake Bagela, Nagda",
              addressLocality: "Eklingji",
              addressRegion: "Udaipur",
              postalCode: "313202",
              addressCountry: "IN",
            },
            telephone: "+919105700099",
            email: "booking@sarasiruhamresort.com",
            url: "https://sarasiruhamresort.com",
            sameAs: [
              "https://www.instagram.com/sarasiruham/",
              "https://www.facebook.com/sarasiruham/",
              "https://www.linkedin.com/company/sarasiruham-resort",
              "https://www.tripadvisor.com/Hotel_Review-g1187340-d3073202560-Reviews-Sarasiruham_Resort_Private_Pool_Villa-Eklingji_Udaipur_District_Rajasthan.html",
            ],
          }),
        }}
      />
      <Banner
        title={banner?.BannerTitle || "About Sarasiruham Resort"}
        description={banner?.Description}
        bgImage={banner?.BannerImage}
      />

      {/* Resort Facts Section (CMS Content if available) */}
      {lookUpCMSData?.["About - Section 5 : Sarasiruham – Resort Facts"] && (
        <section className="py-20 bg-[#fdfcfa] border-b border-[#5a6f3e]/15">
          <div
            dangerouslySetInnerHTML={{
              __html: cleanHeaderTags(
                lookUpCMSData?.[
                  "About - Section 5 : Sarasiruham – Resort Facts"
                ]?.Template,
              ),
            }}
          />
        </section>
      )}

      {/* Resort Facts Single Page Display */}
      {/* <section className="py-20 md:py-28 bg-[#fdfcfa] border-b border-[#5a6f3e]/15 relative overflow-hidden"> */}
      {/* Decorative ambient background glows */}
      {/* <div className="absolute top-0 right-0 w-96 h-96 bg-[#d4af37]/5 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#5a6f3e]/5 rounded-full blur-3xl pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 relative z-10 space-y-20"> */}
      {/* Header Overview */}
      {/* <FadeInSection>
            <div className="text-center max-w-4xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#5a6f3e]/10 text-[#5a6f3e] text-xs font-semibold uppercase tracking-widest mb-4">
                <Sparkles className="w-3.5 h-3.5 text-[#d4af37]" />
                Resort Overview & Quick Facts
              </div>
              <h2
                className="text-4xl md:text-5xl lg:text-6xl text-[#2a2520] mb-6"
                style={{ fontFamily: "Cormorant Garamond, serif", fontWeight: 400 }}
              >
                Sarasiruham –{" "}
                <span className="font-semibold italic text-[#5a6f3e]">
                  Resort Facts
                </span>
              </h2>
              <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent mx-auto mb-6" />
              <p
                className="text-[#2a2520]/85 text-base md:text-lg leading-relaxed"
                style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
              >
                Sarasiruham Resort is a luxury resort in Udaipur, located on the banks of Lake Bagela,
                Nagda, near Eklingji, on the outskirts of Udaipur, Rajasthan. Recognized as one of the
                best resorts near Udaipur for peaceful stays, destination weddings, and private
                celebrations, it offers a rare setting where nature, luxury, and hospitality come
                together away from the city's noise.
              </p>
            </div>
          </FadeInSection> */}

      {/* Location & Connectivity Section */}
      {/* <FadeInSection>
            <div className="bg-white rounded-3xl p-6 md:p-10 border border-[#5a6f3e]/15 shadow-xl">
              <div className="flex items-center gap-3 mb-8 pb-4 border-b border-[#5a6f3e]/10">
                <MapPin className="w-7 h-7 text-[#d4af37]" />
                <h3
                  className="text-2xl md:text-3xl text-[#2a2520]"
                  style={{ fontFamily: "Cormorant Garamond, serif", fontWeight: 600 }}
                >
                  Location & Connectivity
                </h3>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                {locationFacts.map((fact, index) => {
                  const Icon = fact.icon;
                  return (
                    <motion.div
                      key={index}
                      whileHover={{ y: -4 }}
                      className="p-6 rounded-2xl bg-[#fdfcfa] border border-[#5a6f3e]/10 hover:border-[#d4af37]/40 transition-all flex items-start gap-4 shadow-sm"
                    >
                      <div className="p-3 rounded-xl bg-[#5a6f3e]/10 text-[#5a6f3e] flex-shrink-0">
                        <Icon className="w-6 h-6" />
                      </div>
                      <div>
                        <span
                          className="text-xs uppercase tracking-wider text-[#5a6f3e] font-semibold block mb-1"
                          style={{ fontFamily: "Jost, sans-serif" }}
                        >
                          {fact.label}
                        </span>
                        <p
                          className="text-[#2a2520] text-sm md:text-base font-medium leading-relaxed"
                          style={{ fontFamily: "Jost, sans-serif" }}
                        >
                          {fact.value}
                        </p>
                      </div>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          </FadeInSection> */}

      {/* Rooms & Suites */}
      {/* <FadeInSection>
        <div>
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="text-xs uppercase tracking-widest text-[#d4af37] font-semibold block mb-2">
              Accommodations
            </span>
            <h3
              className="text-3xl md:text-4xl text-[#2a2520] mb-3"
              style={{
                fontFamily: "Cormorant Garamond, serif",
                fontWeight: 600,
              }}
            >
              Rooms & Suites
            </h3>
            <p className="text-sm md:text-base text-[#2a2520]/80 font-light">
              Sarasiruham Resort offers 3 room categories; each designed around
              a different view and experience:
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {roomCategories.map((room, idx) => {
              const Icon = room.icon;
              return (
                <motion.div
                  key={idx}
                  whileHover={{ y: -8 }}
                  className="bg-white rounded-3xl p-8 border border-[#5a6f3e]/15 shadow-xl hover:border-[#d4af37]/50 flex flex-col justify-between transition-all duration-300"
                >
                  <div>
                    <div className="flex items-center gap-4 mb-4">
                      <div className="w-14 h-14 rounded-2xl bg-[#5a6f3e]/10 text-[#5a6f3e] flex items-center justify-center shrink-0">
                        <Icon className="w-7 h-7" />
                      </div>
                      <h4
                        className="text-2xl text-[#2a2520]"
                        style={{
                          fontFamily: "Cormorant Garamond, serif",
                          fontWeight: 600,
                        }}
                      >
                        {room.name}
                      </h4>
                    </div>
                    <span className="text-xs uppercase tracking-widest text-[#d4af37] font-semibold block mb-2">
                      {room.size}
                    </span>
                    <p className="text-xs text-[#5a6f3e] font-medium mb-4 italic">
                      {room.tagline}
                    </p>
                    <p
                      className="text-[#2a2520]/80 text-sm leading-relaxed font-light"
                      style={{ fontFamily: "Jost, sans-serif" }}
                    >
                      {room.description}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </FadeInSection> */}

      {/* Events & Celebrations */}
      {/* PART 3: Events & Celebrations (Lakeside Metric Banner Layout) */}
      {/* <FadeInSection>
            <div className="bg-gradient-to-r from-[#5a6f3e] to-[#4a5f2e] rounded-3xl p-8 md:p-12 text-white shadow-2xl relative overflow-hidden">
              <div className="absolute right-0 bottom-0 opacity-10 pointer-events-none">
                <Sparkles className="w-96 h-96 text-white" />
              </div>

              <div className="relative z-10 grid lg:grid-cols-12 gap-8 items-center">
                <div className="lg:col-span-5 space-y-4">
                  <span className="text-xs uppercase tracking-widest text-[#d4af37] font-semibold">
                    Events & Celebrations
                  </span>
                  <h3
                    className="text-3xl md:text-4xl leading-tight"
                    style={{ fontFamily: "Cormorant Garamond, serif", fontWeight: 600 }}
                  >
                    Events of Every Scale (Up to 250 Guests)
                  </h3>
                  <p className="text-white/85 text-sm md:text-base font-light leading-relaxed">
                    Sarasiruham Resort hosts events across indoor halls, poolside venues, rooftop terraces, and open lakeside lawns.
                  </p>
                </div>

                <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
                  {eventsList.map((ev, i) => (
                    <div
                      key={i}
                      className="bg-white/10 backdrop-blur-md border border-white/15 p-4 rounded-xl hover:bg-white/20 transition-all"
                    >
                      <h4
                        className="text-lg font-semibold text-white mb-1 flex items-center gap-2"
                        style={{ fontFamily: "Cormorant Garamond, serif" }}
                      >
                        <Sparkles className="w-4 h-4 text-[#d4af37]" />
                        {ev.title}
                      </h4>
                      <p className="text-xs text-white/80 font-light leading-snug">
                        {ev.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </FadeInSection> */}

      {/* World-Class Amenities */}
      {/* <FadeInSection>
            <div>
              <div className="text-center max-w-3xl mx-auto mb-12">
                <span className="text-xs uppercase tracking-widest text-[#d4af37] font-semibold block mb-2">
                  Resort Facilities
                </span>
                <h3
                  className="text-3xl md:text-4xl text-[#2a2520] mb-3"
                  style={{ fontFamily: "Cormorant Garamond, serif", fontWeight: 600 }}
                >
                  World-Class Amenities
                </h3>
                <p className="text-sm md:text-base text-[#2a2520]/80 font-light">
                  Everything you need to make your stay awesome at Sarasiruham Resort & Spa
                </p>
              </div>

              <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
                {amenities.map((item, idx) => {
                  const Icon = item.icon;
                  return (
                    <motion.div
                      key={idx}
                      whileHover={{ y: -6, scale: 1.02 }}
                      className="bg-white rounded-2xl p-6 border border-[#5a6f3e]/15 shadow-md hover:shadow-xl hover:border-[#d4af37]/40 text-center transition-all duration-300"
                    >
                      <div className="w-12 h-12 rounded-xl bg-[#5a6f3e]/10 text-[#5a6f3e] flex items-center justify-center mx-auto mb-4">
                        <Icon className="w-6 h-6" />
                      </div>
                      <h4
                        className="text-base text-[#2a2520] font-semibold mb-1"
                        style={{ fontFamily: "Cormorant Garamond, serif" }}
                      >
                        {item.title}
                      </h4>
                      <p
                        className="text-xs text-[#2a2520]/70 font-light"
                        style={{ fontFamily: "Jost, sans-serif" }}
                      >
                        {item.desc}
                      </p>
                    </motion.div>
                  );
                })}
              </div>
            </div>
          </FadeInSection> */}
      {/* </div>
      </section> */}

      {/* Introduction */}
      {lookUpCMSData?.["About - Section 1 : Our Story"] && (
        <section className="py-20 bg-[#fdfcfa]">
          <div className="max-w-6xl mx-auto px-6">
            <FadeInSection>
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <motion.div
                    whileHover={{ scale: 1.02 }}
                    className="relative overflow-hidden shadow-2xl h-[500px]"
                  >
                    <Image
                      src={
                        isValidImgSrc(
                          lookUpCMSData?.["About - Section 1 : Our Story"]
                            ?.CMSImage,
                        )
                          ? lookUpCMSData?.["About - Section 1 : Our Story"]
                              ?.CMSImage
                          : "/imports/placeholder.png"
                      }
                      alt={
                        lookUpCMSData?.["About - Section 1 : Our Story"]
                          ?.CMSImageAlterTag || "Banner Image"
                      }
                      fill
                      className="object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
                  </motion.div>
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: cleanHeaderTags(
                      lookUpCMSData?.["About - Section 1 : Our Story"]
                        ?.Template,
                    ),
                  }}
                />
                {/* <div>
                <p
                  className="text-[#c9a961] tracking-[0.3em] mb-4 uppercase"
                  style={{
                    fontFamily: "Jost, sans-serif",
                    fontSize: "0.875rem",
                    fontWeight: 500,
                  }}
                >
                  Our Story
                </p>

                <h2
                  className="text-4xl md:text-5xl text-[#2a2520] mb-6"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontWeight: 600,
                  }}
                >
                  Where Heritage Meets Modern Luxury
                </h2>

                <div
                  className="space-y-4 text-lg text-[#2a2520]/80 leading-relaxed"
                  style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
                >
                  <p>
                    Designed for discerning travelers, Sarasiruham Resort blends
                    elegant architecture, curated experiences, and personalized
                    hospitality to create unforgettable stays in the heart of
                    Rajasthan.
                  </p>
                  <p>
                    Located near the sacred Eklingji Temple and the magnificent
                    Lake Bagela in Nagda, our resort offers a perfect blend of
                    spiritual tranquility and royal luxury that Rajasthan is
                    renowned for.
                  </p>
                  <p>
                    From our meticulously designed private pool villas to our
                    world-class dining venues, every element reflects our
                    commitment to excellence and our deep respect for the
                    region&apos;s rich cultural heritage.
                  </p>
                </div>
              </div> */}
              </div>
            </FadeInSection>
          </div>
        </section>
      )}

      {/* Our Philosophy */}
      {lookUpCMSData?.["About - Section 2 : Our Philosophy"] && (
        <section className="py-20 bg-gradient-to-br from-[#f5f1ec] to-[#fdfcfa]">
          <div
            className="max-w-6xl mx-auto px-6"
            dangerouslySetInnerHTML={{
              __html: cleanHeaderTags(
                lookUpCMSData?.["About - Section 2 : Our Philosophy"]?.Template,
              ),
            }}
          />
          {/* <div className="max-w-6xl mx-auto px-6">
            <FadeInSection>
              <div className="text-center mb-16">
                <Leaf className="w-16 h-16 text-[#5a6f3e] mx-auto mb-6" />

                <h2
                  className="text-4xl md:text-5xl text-[#2a2520] mb-6"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontWeight: 600,
                  }}
                >
                  Our Philosophy
                </h2>

                <p
                  className="text-xl text-[#2a2520]/80 max-w-3xl mx-auto leading-relaxed"
                  style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
                >
                  At Sarasiruham Resort, we believe true luxury lies in peace,
                  privacy, and personalized care. Every detail—from our
                  thoughtfully designed rooms to our immersive experiences—is
                  crafted to reconnect you with nature and yourself.
                </p>
              </div>
            </FadeInSection>

            <div className="grid md:grid-cols-2 gap-6">
              {[
                {
                  icon: Heart,
                  title: "Personalized Care",
                  description:
                    "Every guest receives individual attention with customized services tailored to their preferences and needs.",
                },
                {
                  icon: Shield,
                  title: "Privacy & Comfort",
                  description:
                    "Secluded spaces and exclusive amenities ensure complete privacy and unparalleled comfort throughout your stay.",
                },
                {
                  icon: Leaf,
                  title: "Nature Connection",
                  description:
                    "Surrounded by pristine landscapes, our resort brings you closer to nature's serenity and beauty.",
                },
                {
                  icon: Sparkles,
                  title: "Authentic Experiences",
                  description:
                    "Curated local experiences and cultural activities that showcase the best of Rajasthan's heritage.",
                },
              ].map((item, index) => (
                <FadeInSection key={index} delay={index * 0.1}>
                  <motion.div
                    whileHover={{
                      y: -5,
                      boxShadow: "0 20px 40px rgba(90, 111, 62, 0.15)",
                    }}
                    className="bg-white p-6 sm:p-7 shadow-lg border border-[#5a6f3e]/10 h-full flex flex-col justify-center"
                  >
                    <div className="flex items-center gap-3.5 mb-2.5">
                      <item.icon className="w-8 h-8 sm:w-9 sm:h-9 text-[#d4af37] shrink-0" />
                      <h3
                        className="text-xl sm:text-2xl text-[#2a2520]"
                        style={{
                          fontFamily: "Cormorant Garamond, serif",
                          fontWeight: 600,
                        }}
                      >
                        {item.title}
                      </h3>
                    </div>
                    <p
                      className="text-[#2a2520]/70 leading-relaxed text-sm sm:text-base"
                      style={{
                        fontFamily: "Jost, sans-serif",
                        fontWeight: 300,
                      }}
                    >
                      {item.description}
                    </p>
                  </motion.div>
                </FadeInSection>
              ))}
            </div>
          </div> */}
        </section>
      )}

      {/* What Sets Us Apart */}
      {/* <section className="py-20 bg-[#fdfcfa]">
        <div className="max-w-6xl mx-auto px-6">
          <FadeInSection>
            <div className="text-center mb-16">
              <Award className="w-16 h-16 text-[#d4af37] mx-auto mb-6" />

              <h2
                className="text-4xl md:text-5xl text-[#2a2520] mb-6"
                style={{
                  fontFamily: "Cormorant Garamond, serif",
                  fontWeight: 600,
                }}
              >
                What Sets Us Apart
              </h2>
            </div>
          </FadeInSection>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                image:
                  "https://images.unsplash.com/photo-1667403206567-24feffec7f31?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800",
                title: "Private Villas & Premium Suites",
                description:
                  "Luxurious accommodations featuring private pools, elegant interiors, and world-class amenities.",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1559108710-3d9622f5a861?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800",
                title: "Scenic Natural Surroundings",
                description:
                  "Nestled by Lake Bagela with breathtaking views of Aravalli hills and lush landscapes.",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1769773297747-bd00e31b33aa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800",
                title: "Fine Dining Experiences",
                description:
                  "Five unique dining venues offering multi-cuisine delicacies and authentic Rajasthani flavors.",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1540555700478-4be289fbecef?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800",
                title: "Wellness & Rejuvenation",
                description:
                  "Full-service spa, yoga sessions, and holistic wellness programs for complete relaxation.",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1519167758481-83f29da8c397?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800",
                title: "Dedicated Guest Services",
                description:
                  "24/7 personalized concierge, airport transfers, and customized activity planning.",
              },
              {
                image:
                  "https://images.unsplash.com/photo-1587271407850-8d438ca9fdf2?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800",
                title: "Wedding & Event Venues",
                description:
                  "Five stunning venues for destination weddings and celebrations with complete planning services.",
              },
            ].map((item, index) => (
              <FadeInSection key={index} delay={index * 0.1}>
                <motion.div whileHover={{ y: -8 }} className="group">
                  <div className="relative overflow-hidden mb-4 shadow-xl h-64">
                    <Image
                      src={item.image}
                      alt={item.title}
                      fill
                      className="object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  </div>
                  <h3
                    className="text-xl text-[#2a2520] mb-2"
                    style={{
                      fontFamily: "Cormorant Garamond, serif",
                      fontWeight: 600,
                    }}
                  >
                    {item.title}
                  </h3>
                  <p
                    className="text-[#2a2520]/70"
                    style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
                  >
                    {item.description}
                  </p>
                </motion.div>
              </FadeInSection>
            ))}
          </div>
        </div>
      </section> */}

      {/* Our Vision */}
      {lookUpCMSData?.["About - Section 3 : Our Vision"] && (
        <section className="py-20 bg-gradient-to-br from-[#5a6f3e] to-[#4a5f2e] text-white relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div
              className="absolute inset-0"
              style={{
                backgroundImage:
                  "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
                backgroundSize: "40px 40px",
              }}
            />
          </div>

          <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
            <FadeInSection>
              <div
                dangerouslySetInnerHTML={{
                  __html: cleanHeaderTags(
                    lookUpCMSData?.["About - Section 3 : Our Vision"]?.Template,
                  ),
                }}
              />
              {/* <Target className="w-16 h-16 text-[#d4af37] mx-auto mb-8" />

            <h2
              className="text-4xl md:text-5xl mb-6"
              style={{
                fontFamily: "Cormorant Garamond, serif",
                fontWeight: 600,
              }}
            >
              Our Vision
            </h2>

            <p
              className="text-2xl text-white/95 leading-relaxed mb-8"
              style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
            >
              To be recognized as one of India&apos;s most sought-after luxury
              retreats, offering authentic experiences with world-class comfort.
            </p>

            <p
              className="text-lg text-white/80"
              style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
            >
              We strive to set new standards in hospitality by combining
              Rajasthan&apos;s royal heritage with contemporary luxury, creating
              a destination where every moment becomes a cherished memory.
            </p> */}
            </FadeInSection>
          </div>
        </section>
      )}

      {/* Tripadvisor Travellers' Choice 2026 Recognition Section */}
      {lookUpCMSData?.["About - Section 6 : Recognized By Tripadvisor"] && (
        <section className="py-20 md:py-28 bg-[#fdfcfa] border-b border-[#5a6f3e]/15 relative overflow-hidden">
          {/* Decorative ambient background glows */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#d4af37]/5 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#5a6f3e]/5 rounded-full blur-3xl pointer-events-none" />
          {/* Tripadvisor Logo Badge */}
          <div className="flex justify-center mb-8">
            <div className="relative w-[300px] sm:w-[380px] md:w-[440px] h-[72px] sm:h-[90px] md:h-[105px]">
              <Image
                src={
                  isValidImgSrc(
                    lookUpCMSData?.[
                      "About - Section 6 : Recognized By Tripadvisor"
                    ]?.CMSImage,
                  )
                    ? lookUpCMSData?.[
                        "About - Section 6 : Recognized By Tripadvisor"
                      ]?.CMSImage
                    : "/imports/placeholder.png"
                }
                alt={
                  lookUpCMSData?.[
                    "About - Section 6 : Recognized By Tripadvisor"
                  ]?.CMSImageAlterTag || "Tripadvisor Logo"
                }
                fill
                className="object-contain"
                priority
              />
            </div>
          </div>

          <div
            className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10"
            dangerouslySetInnerHTML={{
              __html: cleanHeaderTags(
                lookUpCMSData?.["About - Section 6 : Recognized By Tripadvisor"]
                  ?.Template,
              ),
            }}
          />
          {/* <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10">
            <FadeInSection>
              <div className="text-center max-w-4xl mx-auto">
                <span
                  className="text-xs uppercase tracking-widest text-[#d4af37] font-semibold block mb-3"
                  style={{ fontFamily: "Jost, sans-serif" }}
                >
                  Proud To Be Recognized
                </span>

                <h2
                  className="text-4xl md:text-5xl lg:text-6xl text-[#2a2520] mb-6 leading-tight uppercase"
                  style={{
                    fontFamily: "Cormorant Garamond, serif",
                    fontWeight: 600,
                  }}
                >
                  Among The World&apos;s
                  <br />
                  Finest Boutique Resorts
                </h2>

                <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent mx-auto mb-6" />

                <p
                  className="text-[#2a2520]/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto"
                  style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
                >
                  This recognition belongs to our wonderful guests whose trust,
                  love and memories inspire us every day.
                </p>
              </div>
            </FadeInSection>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 lg:gap-10 max-w-5xl mx-auto mt-14 sm:mt-16">
              {[
                {
                  rank: "#2",
                  categoryLine1: "LUXURY",
                  categoryLine2: "RESORT",
                  region: "INDIA",
                  icon: Crown,
                  color: "#152c4a",
                },
                {
                  rank: "#2",
                  categoryLine1: "SMALL & BOUTIQUE",
                  categoryLine2: "RESORT",
                  region: "INDIA",
                  icon: Crown,
                  color: "#a85834",
                },
                {
                  rank: "#3",
                  categoryLine1: "SMALL & BOUTIQUE",
                  categoryLine2: "RESORT",
                  region: "ASIA",
                  icon: Globe,
                  color: "#5a6f3e",
                },
                {
                  rank: "#4",
                  categoryLine1: "SMALL & BOUTIQUE",
                  categoryLine2: "RESORT",
                  region: "WORLD",
                  icon: Globe,
                  color: "#c49339",
                },
              ].map((item, index) => {
                const Icon = item.icon;
                return (
                  <FadeInSection key={index} delay={index * 0.12}>
                    <motion.div
                      whileHover={{ y: -8 }}
                      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      className="flex flex-col items-center group cursor-pointer"
                    >
                      <div
                        className="w-full bg-white rounded-t-[70px] sm:rounded-t-[85px] md:rounded-t-[95px] rounded-b-xl sm:rounded-b-2xl border-2 p-3.5 sm:p-4 md:p-5 flex flex-col items-center justify-between shadow-md group-hover:shadow-2xl transition-all duration-300 h-[230px] sm:h-[250px] md:h-[280px]"
                        style={{ borderColor: item.color }}
                      >
                        <div
                          className="w-13 h-13 sm:w-15 sm:h-15 md:w-16 md:h-16 rounded-full flex items-center justify-center shadow-md transition-transform duration-300 group-hover:scale-105 mt-1"
                          style={{ backgroundColor: item.color }}
                        >
                          <Icon
                            className="w-6 h-6 sm:w-7 sm:h-7 text-white"
                            strokeWidth={2}
                          />
                        </div>
                        <div className="text-center my-1">
                          <span
                            className="block text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase"
                            style={{
                              color: item.color,
                              fontFamily: "Jost, sans-serif",
                            }}
                          >
                            RANK
                          </span>
                          <span
                            className="block text-4xl sm:text-5xl md:text-6xl leading-none"
                            style={{
                              color: item.color,
                              fontFamily: "Cormorant Garamond, serif",
                              fontWeight: 600,
                              lineHeight: 0.5,
                            }}
                          >
                            {item.rank}
                          </span>
                        </div>
                        <div
                          className="w-full rounded-md sm:rounded-lg py-2 px-1 text-center shadow-xs"
                          style={{ backgroundColor: item.color }}
                        >
                          <span
                            className="block text-[10px] sm:text-xs font-semibold text-white uppercase tracking-wider leading-tight"
                            style={{ fontFamily: "Jost, sans-serif" }}
                          >
                            {item.categoryLine1}
                            {item.categoryLine2 && (
                              <>
                                <br />
                                {item.categoryLine2}
                              </>
                            )}
                          </span>
                        </div>
                      </div>
                      <h3
                        className="text-2xl sm:text-3xl md:text-4xl text-center mt-3 sm:mt-4 uppercase tracking-widest transition-colors duration-300"
                        style={{
                          color: item.color,
                          fontFamily: "Cormorant Garamond, serif",
                          fontWeight: 600,
                        }}
                      >
                        {item.region}
                      </h3>
                    </motion.div>
                  </FadeInSection>
                );
              })}
            </div>
          </div> */}
        </section>
      )}

      {/* Our Promise */}
      {lookUpCMSData?.["About - Section 4 : Our Promise"] && (
        <section className="py-20 bg-[#fdfcfa] mb-20">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <FadeInSection>
              <div className="bg-white shadow-2xl p-12 md:p-16 border-4 border-[#d4af37]">
                <div
                  dangerouslySetInnerHTML={{
                    __html: cleanHeaderTags(
                      lookUpCMSData?.["About - Section 4 : Our Promise"]
                        ?.Template,
                    ),
                  }}
                />
                {/* <Heart className="w-16 h-16 text-[#d4af37] mx-auto mb-6" />

              <h2
                className="text-4xl md:text-5xl text-[#2a2520] mb-8"
                style={{
                  fontFamily: "Cormorant Garamond, serif",
                  fontWeight: 600,
                }}
              >
                Our Promise
              </h2>

              <p
                className="text-3xl text-[#2a2520] mb-8 leading-relaxed"
                style={{
                  fontFamily: "Cormorant Garamond, serif",
                  fontStyle: "italic",
                  fontWeight: 400,
                }}
              >
                &quot;Every stay is designed to be memorable, meaningful, and
                truly luxurious.&quot;
              </p>

              <p
                className="text-lg text-[#2a2520]/70 mb-10"
                style={{ fontFamily: "Jost, sans-serif", fontWeight: 300 }}
              >
                From the moment you arrive until your departure, our dedicated
                team ensures every detail exceeds your expectations, creating an
                experience you&apos;ll treasure forever.
              </p> */}

                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Link
                    href="/contact"
                    className="inline-block bg-[#5a6f3e] text-white px-10 py-4 hover:bg-[#4a5f2e] transition-colors shadow-lg text-lg"
                    style={{ fontFamily: "Jost, sans-serif", fontWeight: 600 }}
                  >
                    Plan Your Visit Today
                  </Link>
                </motion.div>
              </div>
            </FadeInSection>
          </div>
        </section>
      )}
    </div>
  );
}
